import { Component } from 'vue-property-decorator'
import { GForm } from '@/components/forms/GForm'

const { VUE_APP_WEB_URL } = process.env

@Component
export class StockDetailView extends GForm {
  async copyVehicleToClipboard (stock, files) {
    const car = await this.fetchData({
      query: { model: 'Car', name: 'find' },
      filter: { auto: { id: { _eq: stock.auto.id } } },
    })

    if (!car.length) return

    const validFiles = Object.entries(files)
      .filter(([key, value]: [key: string, value: Record<string, any>]) => value?.photo?.[0]?.file?.uri)
      .map(([key, value]: [key: string, value: Record<string, any>]) => {
        const link = value?.photo?.[0]?.file.uri
        return `${key}=${encodeURIComponent(link as string)}`
      }) // Encodificar cada valor para la URL
      .join('&')
    const url = `${VUE_APP_WEB_URL}${car[0].id}?${validFiles}`

    await navigator.clipboard.writeText(url)
  }
}
